module.exports = __webpack_public_path__ + "img/ic_design_item1.cce87374.png";